<template>
  <v-layout column>
    <!-- TODO: -->
    <!-- 1. Create table with displaying information -->
    <!-- 2. Make an button to create a new user-group -->
    <!-- 3. Create a dialog to create the user-group -->
    <!-- 4. Queries needed: get user groups, create user group -->
    <!-- 5. Display the status of the requests, loading bar, update information -->

    <!-- Title -->
    <v-layout row>
      <span class="admin-title">Document Management</span>
    </v-layout>

    <!-- New user group button -->
    <v-layout
      row
      class="mb-3"
    >
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        depressed
        @click="openNewUGDialog()"
      >New user group</v-btn>
    </v-layout>

    <!-- Table -->
    <v-data-table
      v-if="groups && groupsPageInfo"
      :headers="headers"
      :items="groups"
      sort-icon=""
      class="flat mb-2 table-border"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="currentPagination"
      :total-items="groupsPageInfo.total"
      @update:pagination="updatePagination"
    >
      <!-- :search="search" -->
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ convertDate(props.item.created) }}</td>
          <td>
            {{ displayProviderName(props.item.provider) }}
          </td>
        </tr>
      </template>
    </v-data-table>

    <new-user-group-dialog ref="newUGDialog"></new-user-group-dialog>

  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewUserGroupDialog from '@/components/dialogs/NewUserGroupDialog'

export default {
  components: {
    NewUserGroupDialog
  },
  data() {
    return {
      // TODO: groups, rowsPerPageItems, currentPagination, totalItems
      headers: [
        {
          text: 'User-group ID'
        },
        {
          text: 'Name'
        },
        {
          text: 'Creation Date'
        },
        {
          text: 'Provider'
        }
      ],
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      }
    }
  },
  methods: {
    ...mapActions('admin', ['getUserGroups']),
    openNewUGDialog() {
      this.$refs.newUGDialog.open()
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    displayProviderName(provider) {
      if (provider && provider.organizationName) {
        return provider.organizationName
      } else if (provider) {
        return provider.firstName + ' ' + provider.lastName
      }
    },
    updatePagination(pag) {
      this.getUserGroups({
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage
      })

      console.log('update:pagination', pag)
    }
  },
  computed: {
    ...mapState('admin', ['groups', 'groupsPageInfo'])
  },
  created() {
    this.getUserGroups({ limit: this.currentPagination.rowsPerPage })
  }
}
</script>

<style lang="scss" scoped>
.table-border {
  border: 1px solid #f5f5f5;
}

.admin-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/AdminUserGroupsPage.vue